<template>
  <div class="warp">
    <div class="header_warp" style="width: 100%;">
      <div class="header_logo" style="width: 1200px; margin: 0 auto; height: 60px; line-height: 60px;">
        <div class="logo">
          <div class="title flex justify-center align-center">
            <div class="logoImg">
              <img src="https://static.goubudian.com/Uploads/lottery/2509/68b7b23ce65fe.png" alt="" class="logo" />
              <span>|</span>
              <a href="https://open.work.weixin.qq.com" target="_blank"><img
                  src="https://open.work.weixin.qq.com/service/img?id=ww601e809ac6f5882d&t=isp&c=white&s=small"
                  srcset="https://open.work.weixin.qq.com/service/img?id=ww601e809ac6f5882d&t=isp&c=white&s=small@2x 2x"
                  referrerpolicy="unsafe-url" alt="企业微信"></a>
            </div>
        </div>
      </div>
      <div class="console_warp">
        <div class="btn">
          <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_9 "
            style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
              class="J_floatBtnText m_float_btn__text" @click="go_console">管理后台</span>
          </a>
        </div>
      </div>
    </div>

    </div>
    <div class="h-1010 top_banner">
      <div class="fullmeasureContent">
        <div id="module739" _modulestyle="86" _moduleid="739" class="form form739 formStyle86 siteEditor "
          style="position: absolute; top: 89px; left: 0px; right: 0; margin: 0 auto; width: auto; height: auto;display: flex;justify-content: center;" _side="0"
          data-animations-id="739">
          <div class="lightModuleOuterContent lightModuleOuterContent739">
            <font style="" color="#333333">
              <span style="color: rgb(255, 255, 255);">
                <b><span style="font-size: 65px;">大转盘抽奖工具</span><span style="font-size: 30px; margin-left: 10px;">(企业版)</span></b>
              </span>
            </font>
          </div>
        </div>
  
        <div id="module750" _modulestyle="86" _moduleid="750" class="form form750 formStyle86 siteEditor "
          style="position:absolute;top:185px;left:228px;width:1138px;" _side="0" data-animations-id="750">
          <div class="lightModuleOuterContent lightModuleOuterContent750">
            <font style="" color="#333333">
              <span style="color: rgb(255, 255, 255);">
                <span style="font-size: 30px;">商业促销 / 签到抽奖 / 微信抽奖 / 互动游戏营销 / 收集客户信息</span>
              </span>
            </font>
          </div>
        </div>
  
        <div id="module912" _modulestyle="37" _moduleid="912" class="form form912 formStyle37"
          style="position: absolute; top: 266px; left: 5px; width: 1200px; height: 38px;" _side="0"
          data-animations-id="912">
          <div class=" formMiddle formMiddle912" style="height:38px; ">
            <div class="formMiddleCenter formMiddleCenter912 " valign="top">
              <div class="formMiddleContent formMiddleContent912 fk-formContentOtherPadding" tabstyle="0"
                style="height: 18px; overflow-y: hidden;">
  
                <div class="hdTotal">累计已创建<span id="count-number">20,000,000+</span>个活动</div>
  
              </div>
            </div>
          </div>
        </div>
  
        <div id="module752" _modulestyle="81" _moduleid="752" class="form form752 formStyle81"
          style="position:absolute;top:314px;left:492px;width:217px;border:10px solid transparent;margin-top:-10px;margin-left:-10px;"
          _side="0" data-animations-id="752">
          <div class="lightModuleOuterContent lightModuleOuterContent752">
            <div class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle9 fk-newAM-FloatBtnStyle9">
              <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_9 "
                style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                  class="J_floatBtnText m_float_btn__text"  @click="go_console">我要创建</span>
              </a>
            </div>
          </div>
        </div>
  
        <div id="module916" _modulestyle="37" _moduleid="916" class="form form916 formStyle37"
          style="position: absolute; top: 777px; left: 28px; width: 1130px; height: 55px;" _side="0"
          data-animations-id="916">
          <div class=" formMiddle formMiddle916" style="height:55px; ">
            <div class="formMiddleCenter formMiddleCenter916 " valign="top">
              <div class="formMiddleContent formMiddleContent916 fk-formContentOtherPadding" tabstyle="0"
                style="height: 55px; overflow-y: hidden;">
  
                <div class="statistical content">
                  <div class="item">
                    <div class="title">100+</div>
                    <div class="desc">覆盖行业</div>
                  </div>
                  <div class="item">
                    <div class="title"><span id="enterpriseTrust">300</span>万</div>
                    <div class="desc">企业信赖之选</div>
                  </div>
                  <div class="item">
                    <div class="title"><span id="safeRunning">3,000</span>+天</div>
                    <div class="desc">安全运行</div>
                  </div>
                  <div class="item">
                    <div class="title"><span id="createActive">20,000,000</span><span class="sup">+</span></div>
                    <div class="desc">累计创建活动</div>
                  </div>
                  <div class="item">
                    <div class="title"><span id="totalFlow">1,800,000,000</span><span class="sup"></span>+</div>
                    <div class="desc">累计带来流量</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div id="module754" _modulestyle="86" _moduleid="754" class="form form754 formStyle86 siteEditor "
          style="position: absolute; top: 947px; left: 433px; width: 644px; height: auto;" _side="0"
          data-animations-id="754">
          <div class="lightModuleOuterContent lightModuleOuterContent754">
            <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 48px;"><span
                  style="color: rgb(53, 53, 53);" color="rgba(53, 53, 53, 1)">丰富的功能设置</span></span></div>
          </div>
        </div>
  
      </div>
  
    </div>
  
  
    <div id="module743" _modulestyle="109" _moduleid="743" class="form form743 formStyle109 fk-formFullmeasure "
      style="" _side="0" fmslidestyle="0" fmpage="1" iscarousel="0" displaytime="4" carouselspeed="1" cuscarousel="0"
      data-animations-id="743">
      <div class="fillContentRelative" style="position:absolute; z-index:-1; height:100%; width:100%;display:none;">
      </div>
      <div style="position: static;"
        class="fullmeasureOuterContentPage fullmeasureOuterContentPage1 J_fullmeasurePageShow" page="1">
        <div class="fullmeasureOuterContentBg fullmeasureOuterContentBg743 fullmeasureStyle0"></div>
        <div class="fullmeasureOuterContent fullmeasureOuterContent743">
          <div class="fullmeasureContent fullmeasureContent743" id="fullmeasureContent743_1" moduleid="743">
            <div class="fullmeasureContentBg fullmeasureContentBg743"></div>
            <div class="J_zoneEnableAll J_fullmeasurePackContent elemZone elemZoneModule fk-formPack" moduleid="743"
              id="fk-inFullmeasureListZone743-1">
              <div class="fk-elemZoneBg J_zoneContentBg"></div>
              <div id="module741" _modulestyle="79" _moduleid="741" class="form form741 formStyle79"
                style="position:absolute;top:90px;left:92px;width:160px;" _side="0" data-animations-id="741">
                <div class="lightModuleOuterContent lightModuleOuterContent741">
                  <div class="floatImg floatImg_J floatImg_J_special">
                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin">
                          <img id="float_img_741" class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgrt-rmAYoqf-RQjCgATigAQ.png"
                            src="@/assets/image/ABUIABAEGAAgrt-rmAYoqf-RQjCgATigAQ.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div id="module761" _modulestyle="79" _moduleid="761" class="form form761 formStyle79"
                style="position:absolute;top:358px;left:92px;width:160px;" _side="0" data-animations-id="761">
                <div class="lightModuleOuterContent lightModuleOuterContent761">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_761"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgpuXrmAYow-7A_wIwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAgpuXrmAYow-7A_wIwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module763" _modulestyle="79" _moduleid="763" class="form form763 formStyle79"
                style="position:absolute;top:358px;left:371px;width:160px;" _side="0" data-animations-id="763">
                <div class="lightModuleOuterContent lightModuleOuterContent763">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_763"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAg8ebrmAYolbPDxQMwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAg8ebrmAYolbPDxQMwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module765" _modulestyle="79" _moduleid="765" class="form form765 formStyle79"
                style="position:absolute;top:358px;left:667px;width:160px;" _side="0" data-animations-id="765">
                <div class="lightModuleOuterContent lightModuleOuterContent765">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_765"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgtOfrmAYoq5H6sQYwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAgtOfrmAYoq5H6sQYwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module767" _modulestyle="79" _moduleid="767" class="form form767 formStyle79"
                style="position:absolute;top:358px;left:937px;width:160px;" _side="0" data-animations-id="767">
                <div class="lightModuleOuterContent lightModuleOuterContent767">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_767"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAg8_frmAYooJCvlAYwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAg8_frmAYooJCvlAYwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module755" _modulestyle="79" _moduleid="755" class="form form755 formStyle79"
                style="position:absolute;top:90px;left:371px;width:160px;" _side="0" data-animations-id="755">
                <div class="lightModuleOuterContent lightModuleOuterContent755">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_755"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgnOHrmAYoktfGuQQwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAgnOHrmAYoktfGuQQwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module757" _modulestyle="79" _moduleid="757" class="form form757 formStyle79"
                style="position:absolute;top:90px;left:667px;width:160px;" _side="0" data-animations-id="757">
                <div class="lightModuleOuterContent lightModuleOuterContent757">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_757"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAggOLrmAYor5SA4AcwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAggOLrmAYor5SA4AcwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module759" _modulestyle="79" _moduleid="759" class="form form759 formStyle79"
                style="position:absolute;top:90px;left:937px;width:160px;" _side="0" data-animations-id="759">
                <div class="lightModuleOuterContent lightModuleOuterContent759">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_759"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgweLrmAYosIaRtgIwoAE4oAE.png"
                            src="@/assets/image/ABUIABAEGAAgweLrmAYosIaRtgIwoAE4oAE.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module742" _modulestyle="86" _moduleid="742" class="form form742 formStyle86 siteEditor "
                style="position:absolute;top:264px;left:92px;width:173px;" _side="0" data-animations-id="742">
                <div class="lightModuleOuterContent lightModuleOuterContent742">
                  <div class="fk-editor simpleText   "><span
                      style="color: rgb(102, 102, 102); font-size: 24px;">公众号粉丝专属</span></div>
                </div>
              </div>
              <div id="module756" _modulestyle="86" _moduleid="756" class="form form756 formStyle86 siteEditor "
                style="position:absolute;top:264px;left:370px;width:198px;" _side="0" data-animations-id="756">
                <div class="lightModuleOuterContent lightModuleOuterContent756">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;"><span
                        style="color: rgb(102, 102, 102);">自定义中奖概率</span></span></div>
                </div>
              </div>
              <div id="module758" _modulestyle="86" _moduleid="758" class="form form758 formStyle86 siteEditor "
                style="position:absolute;top:262px;left:664px;width:198px;" _side="0" data-animations-id="758">
                <div class="lightModuleOuterContent lightModuleOuterContent758">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">微信群成员专属</span>
                  </div>
                </div>
              </div>
              <div id="module760" _modulestyle="86" _moduleid="760" class="form form760 formStyle86 siteEditor "
                style="position:absolute;top:264px;left:948px;width:198px;" _side="0" data-animations-id="760">
                <div class="lightModuleOuterContent lightModuleOuterContent760">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">指定地区参与</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfloat clearfloat743"></div>
      </div>
    </div>
  
    <div id="module746" _modulestyle="109" _moduleid="746" class="form form746 formStyle109 fk-formFullmeasure "
      style="" _side="0" fmslidestyle="0" fmpage="1" iscarousel="0" displaytime="4" carouselspeed="1" cuscarousel="0"
      data-animations-id="746">
      <div class="fillContentRelative" style="position:absolute; z-index:-1; height:100%; width:100%;display:none;">
      </div>
      <div style="position: static;"
        class="fullmeasureOuterContentPage fullmeasureOuterContentPage1 J_fullmeasurePageShow" page="1">
        <div class="fullmeasureOuterContentBg fullmeasureOuterContentBg746 fullmeasureStyle0"></div>
        <div class="fullmeasureOuterContent fullmeasureOuterContent746">
          <div class="fullmeasureContent fullmeasureContent746" id="fullmeasureContent746_1" moduleid="746">
            <div class="fullmeasureContentBg fullmeasureContentBg746"></div>
            <div class="J_zoneEnableAll J_fullmeasurePackContent elemZone elemZoneModule fk-formPack" moduleid="746"
              id="fk-inFullmeasureListZone746-1">
              <div class="fk-elemZoneBg J_zoneContentBg"></div>
              <div id="module769" _modulestyle="79" _moduleid="769" class="form form769 formStyle79"
                style="position:absolute;top:431px;left:148px;width:981px;" _side="0" data-animations-id="769">
                <div class="lightModuleOuterContent lightModuleOuterContent769">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_769"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABAEGAAgyuzrmAYo2NPw-AEw1Qc4-gQ.png"
                            src="@/assets/image/ABUIABAEGAAgyuzrmAYo2NPw-AEw1Qc4-gQ.png" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module744" _modulestyle="79" _moduleid="744" class="form form744 formStyle79"
                style="position:absolute;top:551px;left:289px;width:478px;" _side="0" data-animations-id="744">
                <div class="lightModuleOuterContent lightModuleOuterContent744">
                  <div class="floatImg floatImg_J floatImg_J_special"><a hidefocus="true"
                      class="J_floatImg_jump f_floatImg_jump ">
                      <div class="floatImgWrap">
                        <div class="forMargin"><img id="float_img_744"
                            class="lazyload_transparent float_in_img J_defImage"
                            data-original="@/assets/image/ABUIABADGAAgruzrmAYoyuOThAUw3gM4-AI.gif"
                            src="@/assets/image/ABUIABADGAAgruzrmAYoyuOThAUw3gM4-AI.gif" alt="" data-imgloaded="true">
                        </div>
                      </div>
                    </a></div>
                </div>
              </div>
              <div id="module745" _modulestyle="86" _moduleid="745" class="form form745 formStyle86 siteEditor "
                style="position: absolute; top: 271px; left: 432px; width: 602px; height: auto;" _side="0"
                data-animations-id="745">
                <div class="lightModuleOuterContent lightModuleOuterContent745">
                  <div class="fk-editor simpleText   ">
                    <div>
                      <font color="#333333"><span style="font-size: 48px;">极简的制作流程</span></font>
                    </div>
                  </div>
                </div>
              </div>
              <div id="module762" _modulestyle="86" _moduleid="762" class="form form762 formStyle86 siteEditor "
                style="position:absolute;top:4px;left:95px;width:153px;" _side="0" data-animations-id="762">
                <div class="lightModuleOuterContent lightModuleOuterContent762">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">抖音/APP抽奖
                    </span></div>
                </div>
              </div>
              <div id="module764" _modulestyle="86" _moduleid="764" class="form form764 formStyle86 siteEditor "
                style="position:absolute;top:4px;left:378px;width:172px;" _side="0" data-animations-id="764">
                <div class="lightModuleOuterContent lightModuleOuterContent764">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">微信现金红包</span>
                  </div>
                </div>
              </div>
              <div id="module766" _modulestyle="86" _moduleid="766" class="form form766 formStyle86 siteEditor "
                style="position:absolute;top:4px;left:699px;width:172px;" _side="0" data-animations-id="766">
                <div class="lightModuleOuterContent lightModuleOuterContent766">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">活动密码</span>
                  </div>
                </div>
              </div>
              <div id="module768" _modulestyle="86" _moduleid="768" class="form form768 formStyle86 siteEditor "
                style="position:absolute;top:4px;left:955px;width:172px;" _side="0" data-animations-id="768">
                <div class="lightModuleOuterContent lightModuleOuterContent768">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="font-size: 24px;">趣味AR玩法</span>
                  </div>
                </div>
              </div>
              <div id="module770" _modulestyle="81" _moduleid="770" class="form form770 formStyle81"
                style="position:absolute;top:356px;left:515px;width:173px;border:10px solid transparent;margin-top:-10px;margin-left:-10px;"
                _side="0" data-animations-id="770">
                <div class="lightModuleOuterContent lightModuleOuterContent770">
                  <div class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle9 fk-newAM-FloatBtnStyle9"><a
                      id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_9 "
                      style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                        class="J_floatBtnText m_float_btn__text"  @click="go_console">马上体验</span></a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfloat clearfloat746"></div>
      </div>
    </div>
  
    <div id="module753" _modulestyle="109" _moduleid="753" class="form form753 formStyle109 fk-formFullmeasure "
      style="" _side="0" fmslidestyle="0" fmpage="1" iscarousel="0" displaytime="4" carouselspeed="1" cuscarousel="0"
      data-animations-id="753">
      <div class="fillContentRelative" style="position:absolute; z-index:-1; height:100%; width:100%;display:none;">
      </div>
      <div style="position: static;"
        class="fullmeasureOuterContentPage fullmeasureOuterContentPage1 J_fullmeasurePageShow" page="1">
        <div class="fullmeasureOuterContentBg fullmeasureOuterContentBg753 fullmeasureStyle12"></div>
        <div class="fullmeasureOuterContent fullmeasureOuterContent753">
          <div class="fullmeasureContent fullmeasureContent753" id="fullmeasureContent753_1" moduleid="753">
            <div class="fullmeasureContentBg fullmeasureContentBg753"></div>
            <div class="J_zoneEnableAll J_fullmeasurePackContent elemZone elemZoneModule fk-formPack" moduleid="753"
              id="fk-inFullmeasureListZone753-1">
              <div class="fk-elemZoneBg J_zoneContentBg"></div>
              <div id="module776" systempattern="1034" _modulestyle="110" _moduleid="776" _side="0" _infloatlayer="0"
                data-server-rendered="true"
                class="form form776 formStyle110 layoutModule fk-formTabX jz-moduleTabXPattern1034 jz-modulePattern1034 j_tappack__switchevent-click"
                style="width: 1200px; position: absolute; top: 147px; left: 0px; height: 501px;"
                data-animations-id="776">
                <div class="formMiddle formMiddle776" style="height:501px;">
                  <div valign="top" class="formMiddleCenter formMiddleCenter776">
                    <div tabstyle="0"
                      class="formMiddleContent formMiddleContent776 formTabMiddleContent fk-formContentOtherPadding"
                      style="height: 501px; overflow-y: hidden;">
                      <div id="formTab776" class="m_tabpack formTab formTabDirectionX">
                        <div id="formTabContent776"
                          class="elemZone elemZoneModule J_tabPackContent J_tabItemContextMenuTrigger fk-formPack f_tab_pack_content"
                          style="height: 460px;">
                          <div class="item tab_item formTabCntId formTabCntIdHover" style="height: 460px;">
                            <div id="tabPackContent776-0" moduleid="776"
                              class="elemZone elemZoneModule J_tabPackContent J_tabItemContextMenuTrigger fk-formPack f_tab_pack_content"
                              style="height: 460px; display: flex; justify-content: flex-start; align-items: flex-start;flex-wrap: wrap; flex-direction: row;">
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp1.png"
                                            src="@/assets/image/dzp1.png"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">夏日缤纷</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp2.jpg"
                                            src="@/assets/image/dzp2.jpg"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">圣诞颂歌</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp3.png"
                                            src="@/assets/image/dzp3.png"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">幸运抽奖乐</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp4.png"
                                            src="@/assets/image/dzp4.png"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">七夕有理</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp5.jpg"
                                            src="@/assets/image/dzp5.jpg"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">中秋赢大奖</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp6.png"
                                            src="@/assets/image/dzp6.png"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">金秋国庆</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp7.png"
                                            src="@/assets/image/dzp7.png"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">开业享好礼</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div id="module778" _modulestyle="79" _moduleid="778" class="form form778 formStyle79"
                                style="" _side="0" data-animations-id="778">
                                <div class="lightModuleOuterContent lightModuleOuterContent778">
                                  <div class="floatImg floatImg_J floatImg_J_special">
                                    <a hidefocus="true" class="J_floatImg_jump f_floatImg_jump floatImgALink"
                                      id="regBtn_B">
                                      <div class="floatImgWrap">
                                        <div class="forMargin"><img id="float_img_778"
                                            class="lazyload_transparent float_in_img J_defImage"
                                            data-original="@/assets/image/dzp8.jpg"
                                            src="@/assets/image/dzp8.jpg"
                                            alt="" data-imgloaded="true"></div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div id="module798" _modulestyle="81" _moduleid="798" class="form form798 formStyle81"
  
                                  _side="0" data-animations-id="798">
                                  <div class="lightModuleOuterContent lightModuleOuterContent798">
                                    <div
                                      class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle7 fk-newAM-FloatBtnStyle7">
                                      <a id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_7 "
                                        style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                                          class="J_floatBtnText m_float_btn__text">新春抽奖乐</span></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
  
  
  
  
  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="module782" _modulestyle="86" _moduleid="782" class="form form782 formStyle86 siteEditor "
                style="position: absolute; top: 0px; left: 425px; width: 602px; height: auto;" _side="0"
                data-animations-id="782">
                <div class="lightModuleOuterContent lightModuleOuterContent782">
                  <div class="fk-editor simpleText fk-editor-break-word  ">
                    <div>
                      <font color="#333333"><span style="font-size: 48px;">数百款活动皮肤</span></font>
                    </div>
                  </div>
                </div>
              </div>
              <div id="module783" _modulestyle="86" _moduleid="783" class="form form783 formStyle86 siteEditor "
                style="position:absolute;top:77px;left:377px;width:469px;" _side="0" data-animations-id="783">
                <div class="lightModuleOuterContent lightModuleOuterContent783">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span
                      style="color: rgb(141, 141, 141);"><span
                        style="font-size: 24px;">可直接套用！可自定义设计！可专属定制！</span></span></div>
                </div>
              </div>
             <!-- <div id="module788" _modulestyle="81" _moduleid="788" class="form form788 formStyle81"
                style="position:absolute;top:682px;left:501px;width:199px;border:10px solid transparent;margin-top:-10px;margin-left:-10px;"
                _side="0" data-animations-id="788">
                <div class="lightModuleOuterContent lightModuleOuterContent788">
                  <div class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle9 fk-newAM-FloatBtnStyle9"><a
                      id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_9 "
                      style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                        class="J_floatBtnText m_float_btn__text">更多免费皮肤</span></a></div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="clearfloat clearfloat753"></div>
      </div>
    </div>
  
  
    <div id="module786" _modulestyle="109" _moduleid="786" class="form form786 formStyle109 fk-formFullmeasure "
      style="" _side="0" fmslidestyle="0" fmpage="1" iscarousel="0" displaytime="4" carouselspeed="1" cuscarousel="0"
      data-animations-id="786">
  
      <div style="position: static;"
        class="fullmeasureOuterContentPage fullmeasureOuterContentPage1 J_fullmeasurePageShow" page="1">
  
        <div class="fullmeasureOuterContent fullmeasureOuterContent786">
          <div class="fullmeasureContent fullmeasureContent786" id="fullmeasureContent786_1" moduleid="786">
            <div class="fullmeasureContentBg fullmeasureContentBg786"></div>
            <div class="J_zoneEnableAll J_fullmeasurePackContent elemZone elemZoneModule fk-formPack" moduleid="786"
              id="fk-inFullmeasureListZone786-1">
              <div class="fk-elemZoneBg J_zoneContentBg"></div>
              <div id="module785" _modulestyle="86" _moduleid="785" class="form form785 formStyle86 siteEditor "
                style="position: absolute; top: 8px; left: 336px; width: 602px; height: auto;" _side="0"
                data-animations-id="785">
                <div class="lightModuleOuterContent lightModuleOuterContent785">
                  <div class="fk-editor simpleText   ">
                    <div>
                      <font color="#333333"><span style="font-size: 42px;">和他们一起用大转盘抽奖工具</span></font>
                    </div>
                  </div>
                </div>
              </div>
              <div id="module787" _modulestyle="81" _moduleid="787" class="form form787 formStyle81"
                style="position: absolute; top: 102px; left: 513px; width: 173px; border: 10px solid transparent; margin-top: -10px; margin-left: -10px;"
                _side="0" data-animations-id="787">
                <div class="lightModuleOuterContent lightModuleOuterContent787">
                  <div class="J_floatBtnBox floatBtnBox floatBtnStyle floatBtnStyle9 fk-newAM-FloatBtnStyle9"><a
                      id="regBtn_B" class="middle floatBtn float_a_btn m_button_style_9 "
                      style="cursor: pointer; font-family: 微软雅黑; " data-agl-cvt="5"><span
                        class="J_floatBtnText m_float_btn__text"  @click="go_console">一键登录</span></a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfloat clearfloat786"></div>
      </div>
    </div>
  
    <div id="module749" _modulestyle="109" _moduleid="749" class="form form749 formStyle109 fk-formFullmeasure "
      style="" _side="0" fmslidestyle="0" fmpage="1" iscarousel="0" displaytime="4" carouselspeed="1" cuscarousel="0"
      data-animations-id="749">
      <div class="fillContentRelative" style="position:absolute; z-index:-1; height:100%; width:100%;display:none;">
      </div>
      <div style="position: static;"
        class="fullmeasureOuterContentPage fullmeasureOuterContentPage1 J_fullmeasurePageShow" page="1">
        <div class="fullmeasureOuterContentBg fullmeasureOuterContentBg749 fullmeasureStyle0"></div>
        <div class="fullmeasureOuterContent fullmeasureOuterContent749">
          <div class="fullmeasureContent fullmeasureContent749" id="fullmeasureContent749_1" moduleid="749">
            <div class="fullmeasureContentBg fullmeasureContentBg749"></div>
            <div class="J_zoneEnableAll J_fullmeasurePackContent elemZone elemZoneModule fk-formPack" moduleid="749"
              id="fk-inFullmeasureListZone749-1">
              <div class="fk-elemZoneBg J_zoneContentBg"></div>
              <div id="module875" _modulestyle="91" _moduleid="875" class="form form875 formStyle91"
                style="position: absolute; top: 20px; left: 90px; width: 1200px; height: 338px;" _side="0"
                data-animations-id="875">
  
                <div class=" formMiddle formMiddle875" style="height: 293px;">
                  <div class="formMiddleCenter formMiddleCenter875 " valign="top">
                    <div class="formMiddleContent formMiddleContent875 fk-formContentOtherPadding" tabstyle="0"
                      style="height: 300px; overflow-y: hidden;">
                      <div id="photoDotSwitch875"
                        class="J_carouselPhotos photoDotSwitch photoListSwitch carouselPhotosDotSwitch"
                        style="height: 300px; margin: 0px auto; overflow: hidden; width: 1100px;">
  
  
                        <div class="switchGroup"
                          style="width: 1100px; position: relative; overflow: hidden; height: 750px;"><a
                            hidefocus="true" class="carousel-img"
                            style="outline: none; width: 100%; height: 300px; cursor: default; background-position: 50% 50%; background-repeat: no-repeat; overflow: hidden; position: absolute; display: block; float: left; left: 0px; top: 0px;"
                            onclick="return false;" id="photoListABUIABAEGAAgs_KFmQYoiOGlvwcwuAg4hAI"
                            href="javascript:;" target="_blank" title=""><img
                              src="@/assets/image/ABUIABAEGAAgs_KFmQYoiOGlvwcwuAg4hAI.png"
                              data-original="@/assets/image/ABUIABAEGAAgs_KFmQYoiOGlvwcwuAg4hAI.png"
                              width="1038" height="250" alt="" class="" data-imgloaded="true"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="module879" _modulestyle="86" _moduleid="879" class="form form879 formStyle86 siteEditor "
                style="position:absolute;top:357px;left:269px;width:765px;" _side="0" data-animations-id="879">
                <div class="lightModuleOuterContent lightModuleOuterContent879">
                  <div class="fk-editor simpleText fk-editor-break-word  "><span style="color: rgb(143, 143, 143);"
                      color="rgba(143, 143, 143, 1)"><span style="font-size: 14px;">Copyright © 2021-2025
                        苏州狗不点网络科技有限公司&nbsp;  备案号：苏ICP备2022032336号-1 </span></span></div>
                </div>
              </div>
  
  
  
            </div>
          </div>
        </div>
        <div class="clearfloat clearfloat749"></div>
      </div>
    </div>
	
  </div>
  </div>
</template>

<script>
	
export default {
  name: 'index',
  data() {
    return {
      msg: ''
    }
  },
  methods: {
    go_console(){
		location.href="/#/models";
    }
  },
  created() {
	  
	  setTimeout(function() {
	    var countNum = document.documentElement.querySelector('#count-number');
	    var time;
	  
	    function easeOut(t, b, c, d) {
	      return c * ((t = t / d - 1) * t * t * t * t + 1) + b
	    }
	  
	    function formatter(number) {
	      var ret = Number(number);
	      return isNaN(ret) ? 0 : Number(ret.toFixed(0)).toLocaleString().replace(/\..*/, '')
	    }
	  
	    function run(end) {
	      var num = easeOut(Date.now() - time, 0, end, 1000);
	      countNum.innerText = formatter(num) + '+';
	      if (num >= end) return countNum.innerText = formatter(end) + '+';
	      requestAnimationFrame(run.bind(this, end))
	    };
	    time = Date.now();
	    run(20000000)
	  });
	  setTimeout(function() {
	    var datas = {
	      enterpriseTrust: {
	        el: document.documentElement.querySelector('#enterpriseTrust'),
	        data: 300
	      },
	      safeRunning: {
	        el: document.documentElement.querySelector('#safeRunning'),
	        data: 3000
	      },
	      createActive: {
	        el: document.documentElement.querySelector('#createActive'),
	        data: 20000000
	      },
	      totalFlow: {
	        el: document.documentElement.querySelector('#totalFlow'),
	        data: 1800000000
	      }
	    };
	    var preTime;
	  
	    function easeOut(t, b, c, d) {
	      return c * ((t = t / d - 1) * t * t * t * t + 1) + b
	    }
	  
	    function formatter(number) {
	      var ret = Number(number);
	      return isNaN(ret) ? 0 : Number(ret.toFixed(0)).toLocaleString().replace(/\..*/, '')
	    }
	  
	    function run(time) {
	      var diffTime = Date.now() - preTime;
	      for (const key in datas) {
	        var item = datas[key];
	        var num = easeOut(diffTime, 0, item.data, time);
	        item.el.innerText = formatter(num)
	      }
	      if (diffTime >= time) {
	        for (const key in datas) {
	          var item = datas[key];
	          item.el.innerText = formatter(item.data)
	        }
	        return
	      }
	      requestAnimationFrame(run.bind(this, time))
	    }
	    preTime = Date.now();
	    run(1000)
	  });


  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/scss" lang="scss">
 .statistical{width:1110px;height:50px;border-bottom:1px solid rgba(232,232,232,1);}.statistical .item{position:relative;float:left;width:20%;text-align:center;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;}.statistical .item::after{position:absolute;bottom:-10px;content:'';display:inline-block;width:5px;height:5px;border-radius:5px;background:#70C2FF;}.statistical .item .title{height:21px;line-height:21px;margin-bottom:4px;font-size:24px;font-weight:300;color:rgba(64,72,83,1);}.statistical .item .desc{height:18px;line-height:18px;font-size:18px;font-weight:300;color:rgba(137,137,137,1);}
  .hdTotal{height:1em;line-height:1em;color:#fff;font-family:'微软雅黑',Arial;text-align:center}
  .hdTotal>span{margin:0 5px;color:#ffed22}

  .h-1010{
    height: 1010px;
  }
  #module749 {
      height: 473px;
      overflow: hidden;
          padding: 0;
          position: relative;
          zoom: 1;
          font-size: 12px;
  }
  #module749 .fullmeasureOuterContentPage1 .fullmeasureOuterContentBg749 {
      background: url('../../src/assets/image/ABUIABAEGAAg1IHsmAYok9vi1wMwgA841gM.png') repeat center;

      background-repeat: no-repeat;
  }
  #module798 {
      height: 38px;
  }
  #module798 .floatBtn.middle {
      -webkit-box-shadow: 1px 5px 8px rgba(222, 222, 222, 1);
      -moz-box-shadow: 1px 5px 8px rgba(222, 222, 222, 1);
      box-shadow: 1px 5px 8px rgba(222, 222, 222, 1);
      cursor: pointer;
          display: block;
          overflow: hidden;
          position: relative;
          text-align: center;
          -webkit-text-decoration: none;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 262px;
              height: 38px;
              line-height: 38px;
              border-radius: 4px 4px 4px 4px;
  }
  #module798 .m_float_btn__text {
      -webkit-text-fill-color: initial;
      color: #8d8d8d;
      color: rgba(141, 141, 141, 1);
      font-size: 18px;
      display: block;
  }
  #module788 .floatBtn.middle {
      -webkit-box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
      -moz-box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
      box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
  }
  #module788 .floatBtn {
      -moz-border-radius: 25px 25px 25px 25px;
      -webkit-border-radius: 25px 25px 25px 25px;
      border-radius: 25px 25px 25px 25px;
  }
  #module788 .floatBtn {
      width: 199px;
      height: 52px;
      line-height: 52px;
  }
  #module788 .floatBtn.m_button_style_9 {
      background: rgba(16, 180, 255, 1);
  }

  #module753 {
      height:700px;
      overflow: hidden;
          padding: 0;
          position: relative;
          zoom: 1;
          font-size: 12px;
  }
  .m_tabpack .formTabContent .formTabCntId.formTabCntIdHover {
      visibility: visible;
  }
  .m_tabpack .tab_list .item.formTabCntId {
      left: 5000px;
      top: 100%;
      visibility: hidden;
  }
  .formTabContent .formTabCntIdHover {
      position: static;
      width: auto;
  }
  .formTabContent .formTabCntId {
      clear: both;
      overflow: hidden;
      position: absolute;
      width: 100%;
  }
  .m_tabpack .tab_list .item.formTabCntId {
      left: 5000px;
      top: 100%;
      visibility: hidden;
  }
  .formTabContent .formTabCntId {
      clear: both;
      overflow: hidden;
      position: absolute;
      width: 100%;
  }
  .m_tabpack .formTabContent .formTabCntId.formTabCntIdHover {
      visibility: visible;
  }
  .formTab {
      height: auto;
  }
  #module776 #formTabContent776 {
      border: none;
  }
  .forms .jz-moduleTabXPattern1034 .formTabContent {
      border: none;
  }
  .forms .fk-formTabX .formTabContent {
      border: none;
  }
  .formTabContent {
      background: none;
      border: 1px solid #d4d4d4;
      height: auto;
      overflow: hidden;
      position: relative;
  }
  .formStyle110 .f_tab_pack_content {
      height: 200px;
      width: auto;
  }
  .fk-formPack {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
  }
  .elemZone {
      height: 100%;
      position: relative;
      width: 100%;
      -webkit-box-flex: 1;
      -ms-flex: 1 1;
      flex: 1 1;
  }
  #module778 {
      height: 210px;
      margin: 10px;
  }
  #module778 .floatImg .float_in_img {
      height: 165px;
  }
  #module778 .floatImg .float_in_img {
      width: 262px;
  }
    #module786 {
        height: 242px;
        overflow: hidden;
            padding: 0;
            position: relative;
            zoom: 1;
            font-size: 12px;
    }
    .fk-elemZoneBg {
        height: 100%;
        width: 100%;
    }
    #module787 {
        height: 52px;
    }
    #module787 .floatBtn.m_button_style_9 {
        background: rgba(16, 180, 255, 1);
    }
    #module787 .floatBtn {
        -moz-border-radius: 25px 25px 25px 25px;
        -webkit-border-radius: 25px 25px 25px 25px;
        border-radius: 25px 25px 25px 25px;
    }

    .fullmeasureContent{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

    }
    .fullmeasureOuterContent {
        background: none;
        cursor: default;
        height: 100%;
        position: relative;
    }
    .fullmeasureOuterContentBg {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
    fk-formPack {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }
    .elemZone {
        height: 100%;
        position: relative;
        width: 100%;
        -webkit-box-flex: 1;
        -ms-flex: 1 1;
        flex: 1 1;
    }
    .elemZone, .fk-subNavPack .container, .fk-subNavPack div.formStyle79:hover {
        overflow: hidden;
    }
    .fk-elemZoneBg {
        height: 100%;
        width: 100%;
    }
    .fullmeasureOuterContentPage {
        height: 100%;
        left: 0;
        padding: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
    .fullmeasureContent {
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
        width: 1200px;
    }
    .fullmeasureOuterContent .fk-formPack .form {
        z-index: 1;
    }
    #module770 {
        height: 52px;
    }
    .form .floatBtnBox {
        font-family: Microsoft YaHei;
        font-size: 26px;
        line-height: 52px;
        overflow: visible;
    }
    #module770 .floatBtn.middle {
        -webkit-box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
        -moz-box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
        box-shadow: 1px 5px 8px rgba(144, 202, 248, 1);
    }

    #module770 .floatBtn {
        -moz-border-radius: 25px 25px 25px 25px;
        -webkit-border-radius: 25px 25px 25px 25px;
        border-radius: 25px 25px 25px 25px;
    }
    #module770 .floatBtn {
        width: 173px;
        height: 52px;
        line-height: 52px;
    }
    .form .floatBtnStyle .float_a_btn.middle {
        color: #fff;
        height: 50px;
        line-height: 50px;
        width: 162px;
    }
    .form .floatBtnBox .middle {
        cursor: pointer;
        display: block;
        overflow: hidden;
        position: relative;
        text-align: center;
        -webkit-text-decoration: none;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    div.formStyle81 .floatBtn.m_button_style_9 {
        background: #076ce0;
    }
    #module770 .floatBtn.m_button_style_9 {
        background: rgba(16, 180, 255, 1);
    }
    #module769 {
        height: 638px;
    }
    #module746 {
        height: 1125px;
        border-top: none;
        border-bottom: none;
        overflow: hidden;
        padding: 0;
        position: relative;
        zoom: 1;
        font-size: 12px;
    }
    #module746 .fullmeasureOuterContentPage1 .fullmeasureOuterContentBg746 {
        background: url('../../src/assets/image/ABUIABAEGAAgy97rmAYo0JyppAQwgA841gg.png') repeat center;

    }
  #module743 {
      height: 524px;
      position: relative;
      .fullmeasureOuterContentPage {
          height: 100%;
          left: 0;
          padding: 0;
          position: absolute;
          top: 0;
          width: 100%;
      }
  }

  .top_banner{
    background-image: url('../../src/assets/image/bg.png');
    background-position: center top;


    #module752{
      height: 52px;
      .floatBtn {
          cursor: pointer;
          width: 217px;
          height: 52px;
          line-height: 52px;
          display: block;
          overflow: hidden;
          position: relative;
          text-align: center;
          -webkit-text-decoration: none;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-radius: 23px 23px 23px 23px;

          &.m_button_style_9 {
            background: rgba(254, 221, 77, 1);
            }
      }
      .m_float_btn__text {
          -webkit-text-fill-color: initial;
          color: #4253ae;
          color: rgba(66, 83, 174, 1);
      }
    }
  }
  .header_warp{
    position: fixed;
    left: 0;
    top: 0;
    height: 60px;
    background: rgba(255, 255, 255, 0.9);
    z-index: 100;
    .header_logo{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo{
        width: 360px;
        .title {
            padding-top: 0px;
            .logoImg{
            	display: flex;
            	justify-content:space-around;
            	align-items: center;
            	width:80%;
            	margin:0 auto;
            	.logo{
            		width: auto;
                height: 37px;
            	}
            	span{
            		color: #ECECEC;
            	}
            	a{
            		img{
            			display: block;
            		}
            	}
            }


        }
      }
      .console_warp{
        background: #10b4ff;
        width: 173px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 16px;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue